import {useCallback, useEffect, useState} from 'react';

import {Conversation} from '@stripe-internal/conversations-client';
import {
  isMessageInteractivityEnabled,
  useConversationLogEvents,
  useRestartConversationEvents,
} from '@stripe-internal/conversations-assistant';
import {useConversationPoller} from '@stripe-internal/conversations-ui';

import {MobileLog} from './MobileLog';

type Props = {
  conversation: Conversation;
};

export function MobileAssistantLog({conversation}: Props) {
  const [disableMessageInteractivity, setDisableMessageInteractivity] =
    useState<boolean>(!isMessageInteractivityEnabled(conversation));

  useConversationLogEvents(conversation);
  useRestartConversationEvents();
  // Poll for dynamic assistant responses, matching the web Log component.
  useConversationPoller(conversation);

  const bindToConversationState = useCallback(() => {
    setDisableMessageInteractivity(
      !isMessageInteractivityEnabled(conversation),
    );
  }, [conversation]);

  useEffect(() => {
    bindToConversationState();
  }, [bindToConversationState]);

  return (
    <MobileLog
      conversation={conversation}
      animated
      disableInteraction={disableMessageInteractivity}
    />
  );
}
